// extracted by mini-css-extract-plugin
module.exports = {"email_link":"Button_email_link__IRksU"};